(function (SSC) {
  'use strict';
  SSC.track = function (name, payload) {
    payload = payload || {};
    if (window.dataLayer && Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, payload));
    if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
      try { Shopify.analytics.publish(name, payload); } catch (error) {}
    }
  };
  var seen = typeof WeakSet === 'function' ? new WeakSet() : [];
  function hasSeen(node) { return seen instanceof Array ? seen.indexOf(node) > -1 : seen.has(node); }
  function markSeen(node) { if (seen instanceof Array) seen.push(node); else seen.add(node); }
  function measureLists() {
    document.querySelectorAll('[data-product-grid]').forEach(function (grid) {
      if (hasSeen(grid) || grid.closest('[aria-hidden="true"]')) return;
      var cards = grid.querySelectorAll('[data-product-card]');
      if (!cards.length) return;
      markSeen(grid);
      SSC.track('view_item_list', { items: Array.prototype.map.call(cards, function (card) { return { item_id: card.dataset.productId, item_name: card.dataset.productTitle }; }) });
    });
  }
  measureLists();
  document.addEventListener('ssc:content-updated', measureLists);
  document.addEventListener('click', function (event) {
    var productLink = event.target.closest('[data-product-card] a[href]');
    if (productLink) {
      var card = productLink.closest('[data-product-card]');
      SSC.track('select_item', { items: [{ item_id: card.dataset.productId, item_name: card.dataset.productTitle }] });
    }
    if (event.target.closest('[data-cart-link]')) SSC.track('view_cart');
  });
})(window.SSC || (window.SSC = {}));
